import { NgModule, ModuleWithProviders } from '@angular/core';
import * as services from 'services';

@NgModule()
export class ServicesModule {
	static forRoot(): ModuleWithProviders<ServicesModule> {
		return {
			ngModule: ServicesModule,
			providers: [
				services.AccommodationPricePlanService,
				services.AccommodationService,
				services.AddressService,
				services.AdminNotesService,
				services.AnalyticsService,
				services.BookingPaymentOverrideService,
				services.BookingService,
				services.BreakpointService,
				services.DocumentService,
				services.DownloadFileService,
				services.EmailTemplateService,
				services.IntegrationService,
				services.MembershipService,
				services.OneStepService,
				services.PricePlanService,
				services.ReportService,
				services.SearchService,
				services.SuperhogService,
				services.TextMessageService,
				services.TripService,
				services.UIService,
				services.UploadedFileService,
				services.UserService,
				services.UserSettingAdminService,
				services.VerificationCallbackService,
				services.VerificationLiteService,
				services.VerificationService,
				services.VerificationSetAdminService,
				services.WatchlistService,
			],
		};
	}
}
